"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    NavigationLinks: function() {
        return NavigationLinks;
    },
    NavigationLink: function() {
        return NavigationLink;
    }
});
var _react = _interop_require_wildcard(require("react"));
var _components = require("@cmpsr/components");
var _NavigationContext = require("./NavigationContext");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var NavigationLinks = function(_param) {
    var actions = _param.actions, image = _param.image, children = _param.children, _param_linksPosition = _param.linksPosition, linksPosition = _param_linksPosition === void 0 ? "start" : _param_linksPosition, _param_showDividers = _param.showDividers, showDividers = _param_showDividers === void 0 ? true : _param_showDividers, props = _object_without_properties(_param, [
        "actions",
        "image",
        "children",
        "linksPosition",
        "showDividers"
    ]);
    var _useDisclosure = (0, _components.useDisclosure)(), isOpen = _useDisclosure.isOpen, onOpen = _useDisclosure.onOpen, onClose = _useDisclosure.onClose;
    var _useNavigationContext = (0, _NavigationContext.useNavigationContext)(), showBaseNavigation = _useNavigationContext.showBaseNavigation, keepActionsAlwaysVisible = _useNavigationContext.keepActionsAlwaysVisible;
    return showBaseNavigation ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_components.IconButton, {
        icon: _react.default.createElement(_components.IconMenu2, null),
        "aria-label": "Hamburger menu button",
        variant: "ghost",
        size: "l",
        onClick: onOpen
    }), _react.default.createElement(_components.Flex, {
        justifyContent: "space-between",
        flexBasis: "100%",
        gap: "0.75rem"
    }, image, keepActionsAlwaysVisible && actions), isOpen && _react.default.createElement(_components.Flex, _object_spread({
        width: "100%",
        height: "100%",
        bg: "background-overlay",
        position: "fixed",
        top: "0",
        left: "0",
        zIndex: "1",
        flexDirection: "column"
    }, props), _react.default.createElement(_components.Box, {
        pt: "0.75rem",
        px: "1rem"
    }, _react.default.createElement(_components.IconButton, {
        icon: _react.default.createElement(_components.IconX, null),
        "aria-label": "Close hamburguer menu button",
        variant: "ghost",
        size: "l",
        onClick: onClose
    })), _react.default.createElement(_components.Flex, {
        height: "100%",
        width: "100%",
        px: "1.5rem",
        pt: "3.5rem",
        pb: "3.25rem",
        alignItems: "center",
        flexDirection: "column",
        overflow: "auto"
    }, _react.Children.map(children, function(child, index) {
        return (0, _react.isValidElement)(child) && (0, _react.cloneElement)(child, {
            showDivider: index === _react.Children.count(children) - 1 ? false : showDividers
        });
    }), !keepActionsAlwaysVisible && actions))) : _react.default.createElement(_components.Flex, _object_spread({
        maxWidth: "80rem",
        margin: "0 auto",
        alignItems: "center",
        width: "100%"
    }, props), _react.default.createElement(_components.Box, {
        flexShrink: "0"
    }, image), _react.default.createElement(_components.Flex, {
        flexBasis: "100%",
        mx: {
            lg: "2.75rem",
            xxl: "4.5rem"
        },
        gap: {
            lg: "1.5rem",
            xl: "2.25rem",
            xxl: "5rem"
        },
        justifyContent: linksPosition
    }, children), _react.default.createElement(_components.Box, {
        flexShrink: "0"
    }, actions));
};
var NavigationLink = function(_param) {
    var showDivider = _param.showDivider, children = _param.children, props = _object_without_properties(_param, [
        "showDivider",
        "children"
    ]);
    var showBaseNavigation = (0, _NavigationContext.useNavigationContext)().showBaseNavigation;
    return showBaseNavigation ? _react.default.createElement(_react.Fragment, null, _react.default.createElement(_components.Link, _object_spread({
        size: "l",
        justifyContent: "center",
        marginBottom: !showDivider && "3rem",
        variant: "link-secondary"
    }, props), _react.default.createElement(_components.Text, {
        variant: "text-body-display-L",
        color: "unset"
    }, children)), showDivider && _react.default.createElement(_components.Divider, {
        my: "1.50rem",
        maxWidth: "24.75rem"
    })) : _react.default.createElement(_components.Link, _object_spread({
        size: "m",
        variant: "link-secondary"
    }, props), children);
};
